export default __webpack_public_path__ + "static/media/fitness-tracker-rn.83b0b090.jpg";